import React, { Component } from 'react';
import { ErrorMessage, Field, getIn } from 'formik';
import ItemFormCustomSelect from '../../../../common/formElements/ItemFormCustomSelect';
import { getCollectionItemByIds, getCollectionItemList } from '../../../../common/utils/item-util';
import _ from 'lodash';

class Reference extends Component {
  state = { options: [], selectedOptions: [] };

  requiredValidate = (value) => {
    if (this.props.isConstructorForm) {
      return;
    }
    const { required } = this.props.field;
    let error;
    if (required && (!value || value.length === 0)) {
      error = 'This field is required';
    }
    return error;
  };
  mapItemsToOptions = (items = []) => {
    const { field } = this.props;
    const { refCollection } = field;

    return items.map((item) => {
      const label = getIn(item, refCollection.collectionField);

      let labelText;

      if (refCollection.isFileType) {
        if (Array.isArray(label)) {
          labelText = label.map((l) => l.uuid).join(', ');
        } else if (typeof label === 'object') {
          labelText = label ? label.uuid : '';
        }
      } else {
        labelText = label || 'Field value not defined';
      }

      return {
        value: item.uuid,
        label: labelText,
      };
    });
  };

  mergeOptions = (...optionLists) =>
    Array.from(new Map(optionLists.flat().map((option) => [option.value, option])).values());

  loadOptions = async (searchTerm = '') => {
    const { field, projectId, version } = this.props;
    if (!field.refCollection) return;

    const query = { limit: 10, searchTerm };

    const data = await getCollectionItemList(
      projectId,
      version,
      field.refCollection.collectionName,
      query,
    );
    const options = this.mapItemsToOptions(data);
    this.setState((prevState) => ({
      options: this.mergeOptions(
        [{ value: '', label: '-- Select Value --' }],
        prevState.options,
        prevState.selectedOptions,
        options,
      ),
    }));
  };
  loadSelectedOptions = async () => {
    const { field, values, projectId, version } = this.props;
    const fieldValue = getIn(values, field.fieldName);
    if (!fieldValue || (Array.isArray(fieldValue) && fieldValue.length === 0)) {
      return;
    }

    const data = await getCollectionItemByIds(
      projectId,
      version,
      field.refCollection.collectionName,
      Array.isArray(fieldValue) ? fieldValue : [fieldValue],
    );
    const selectedOptions = this.mapItemsToOptions(data);

    this.setState((prevState) => ({
      selectedOptions,
      options: this.mergeOptions(
        [{ value: '', label: '-- Select Value --' }],
        selectedOptions,
        prevState.options,
      ),
    }));
  };

  async componentDidMount() {
    await this.loadOptions();
    await this.loadSelectedOptions();
  }

  componentWillUnmount() {
    this.handleSearch.cancel();
  }

  handleSearch = _.debounce((inputValue) => {
    this.loadOptions(inputValue);
  }, 300);

  render() {
    const { field, values, isConstructorForm } = this.props;
    const { fieldTitle, required, fieldName, type, isMultiSelect } = field;
    const fieldValue = getIn(values, fieldName);
    return (
      <>
        <Field
          as={ItemFormCustomSelect}
          name={fieldName}
          isMulti={isMultiSelect}
          onChange={this.props.setFieldValue}
          onBlur={this.props.setFieldTouched}
          options={this.state.options.length > 0 ? this.state.options : []}
          placeholder={`Please select ${fieldTitle['en']}`}
          value={fieldValue}
          validate={this.requiredValidate}
          title={fieldTitle['en']}
          onInputChange={this.handleSearch}
        />
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}

export default Reference;
